import { ebookRecAction } from '@orientaction/api-actions';
import { isAdminVerify } from '@orientaction/utils';
import { useEffect, useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation, useParams } from 'react-router-dom';
import { apiServiceNative } from '../../../../utils/fetchNative';
import { getBeneficiaryResourcesBackPath } from '../../Tests/shared/adminResultNav';
import EbookReaderLayout from './components/EbookReaderLayout';
import RecrutementContent from './components/RecrutementContent';

type RecrutementParams = {
  id?: string;
  index?: string;
  readOnly?: string;
};

const readOwnerUserId = (payload: any) => {
  const source = payload?.data?.attributes || payload?.data || payload || {};
  const userRef = source.users_permissions_user;
  const id = Number(userRef?.data?.id || userRef?.id || userRef);
  return Number.isFinite(id) && id > 0 ? id : 0;
};

const RedesignEbookRecrutement = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { id, index, readOnly } = useParams<RecrutementParams>();
  const [loading, setLoading] = useState(false);
  const [ownerUserId, setOwnerUserId] = useState(
    () => Number(new URLSearchParams(location.search).get('userId')) || 0
  );
  const readOnlyParse = useMemo(() => readOnly === 'true', [readOnly]);

  useEffect(() => {
    const getDataEbook = async () => {
      if (!id) {
        return;
      }

      setLoading(true);
      const response = await apiServiceNative.get(`/api/ebook-recrutements/${id}`);
      await apiServiceNative.put(`/api/ebook-recrutements/${id}`, {
        data: {
          dateConsultation: new Date(),
        },
      });
      dispatch(ebookRecAction.setAllField(response.data.attributes));
      const userIdFromEbook = readOwnerUserId(response);
      if (userIdFromEbook) {
        setOwnerUserId(userIdFromEbook);
      }
      setLoading(false);
    };

    getDataEbook();
  }, [dispatch, id]);

  return (
    <EbookReaderLayout
      loading={loading}
      readOnly={readOnlyParse}
      index={index ? Number(index) : undefined}
      toBack={isAdminVerify() ? getBeneficiaryResourcesBackPath(ownerUserId) : '/mes-ressources'}
      ebookName="l’Ebook recrutement"
      summaryHref="page-3"
      showFooter={false}>
      {() => <RecrutementContent id={id} readOnly={readOnlyParse} />}
    </EbookReaderLayout>
  );
};

export default RedesignEbookRecrutement;
